import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { useApiAccess } from "./useApiAccess";
import { getParticularArticle } from "../../Service/ArticleService";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { queryKeys } from "./queryKeys";

export function useArticle({ articleSlug }) {
  const hasAccess = useApiAccess();
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const pathParams = { ...(productParam && { product: productParam }) };

  return useQuery(
    queryKeys.article(articleSlug, productParam),
    () => getParticularArticle(articleSlug, pathParams),
    { enabled: !!hasAccess && !!articleSlug }
  );
}
